import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { routes } from 'utils/constants';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from 'utils/context/AuthContext';
import { VariableProvider } from 'utils/context/VariableContext';
import { ModalProvider } from 'utils/context/ModalContext';
import GlobalModals from 'components/modal/GlobalModals';

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <AuthProvider>
        <VariableProvider>
            <ModalProvider>
                <RouterProvider router={router} />
                <GlobalModals />
            </ModalProvider>
        </VariableProvider>        
    </AuthProvider>
);

reportWebVitals();
